/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as MembersRouteImport } from './routes/members';
import { Route as ShareRouteImport } from './routes/share';
import { Route as JoinInviteIdRouteImport } from './routes/join.$inviteId';
import { Route as LittersLitterIdRouteImport } from './routes/litters.$litterId';
import { Route as LittersNewRouteImport } from './routes/litters.new';
import { Route as OffspringOffspringIdRouteImport } from './routes/offspring.$offspringId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const MembersRoute = MembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => rootRouteImport,
} as any);
const ShareRoute = ShareRouteImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => rootRouteImport,
} as any);
const JoinInviteIdRoute = JoinInviteIdRouteImport.update({
  id: '/join/$inviteId',
  path: '/join/$inviteId',
  getParentRoute: () => rootRouteImport,
} as any);
const LittersLitterIdRoute = LittersLitterIdRouteImport.update({
  id: '/litters/$litterId',
  path: '/litters/$litterId',
  getParentRoute: () => rootRouteImport,
} as any);
const LittersNewRoute = LittersNewRouteImport.update({
  id: '/litters/new',
  path: '/litters/new',
  getParentRoute: () => rootRouteImport,
} as any);
const OffspringOffspringIdRoute = OffspringOffspringIdRouteImport.update({
  id: '/offspring/$offspringId',
  path: '/offspring/$offspringId',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/members': typeof MembersRoute;
  '/share': typeof ShareRoute;
  '/join/$inviteId': typeof JoinInviteIdRoute;
  '/litters/$litterId': typeof LittersLitterIdRoute;
  '/litters/new': typeof LittersNewRoute;
  '/offspring/$offspringId': typeof OffspringOffspringIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/members': typeof MembersRoute;
  '/share': typeof ShareRoute;
  '/join/$inviteId': typeof JoinInviteIdRoute;
  '/litters/$litterId': typeof LittersLitterIdRoute;
  '/litters/new': typeof LittersNewRoute;
  '/offspring/$offspringId': typeof OffspringOffspringIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/members': typeof MembersRoute;
  '/share': typeof ShareRoute;
  '/join/$inviteId': typeof JoinInviteIdRoute;
  '/litters/$litterId': typeof LittersLitterIdRoute;
  '/litters/new': typeof LittersNewRoute;
  '/offspring/$offspringId': typeof OffspringOffspringIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/members'
    | '/share'
    | '/join/$inviteId'
    | '/litters/$litterId'
    | '/litters/new'
    | '/offspring/$offspringId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/members'
    | '/share'
    | '/join/$inviteId'
    | '/litters/$litterId'
    | '/litters/new'
    | '/offspring/$offspringId';
  id:
    | '__root__'
    | '/'
    | '/members'
    | '/share'
    | '/join/$inviteId'
    | '/litters/$litterId'
    | '/litters/new'
    | '/offspring/$offspringId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  MembersRoute: typeof MembersRoute;
  ShareRoute: typeof ShareRoute;
  JoinInviteIdRoute: typeof JoinInviteIdRoute;
  LittersLitterIdRoute: typeof LittersLitterIdRoute;
  LittersNewRoute: typeof LittersNewRoute;
  OffspringOffspringIdRoute: typeof OffspringOffspringIdRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/members': {
      id: '/members';
      path: '/members';
      fullPath: '/members';
      preLoaderRoute: typeof MembersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/share': {
      id: '/share';
      path: '/share';
      fullPath: '/share';
      preLoaderRoute: typeof ShareRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/join/$inviteId': {
      id: '/join/$inviteId';
      path: '/join/$inviteId';
      fullPath: '/join/$inviteId';
      preLoaderRoute: typeof JoinInviteIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/litters/$litterId': {
      id: '/litters/$litterId';
      path: '/litters/$litterId';
      fullPath: '/litters/$litterId';
      preLoaderRoute: typeof LittersLitterIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/litters/new': {
      id: '/litters/new';
      path: '/litters/new';
      fullPath: '/litters/new';
      preLoaderRoute: typeof LittersNewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/offspring/$offspringId': {
      id: '/offspring/$offspringId';
      path: '/offspring/$offspringId';
      fullPath: '/offspring/$offspringId';
      preLoaderRoute: typeof OffspringOffspringIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MembersRoute: MembersRoute,
  ShareRoute: ShareRoute,
  JoinInviteIdRoute: JoinInviteIdRoute,
  LittersLitterIdRoute: LittersLitterIdRoute,
  LittersNewRoute: LittersNewRoute,
  OffspringOffspringIdRoute: OffspringOffspringIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
